import script from "./PesosPuestoView.vue?vue&type=script&setup=true&lang=js"
export * from "./PesosPuestoView.vue?vue&type=script&setup=true&lang=js"

import "./PesosPuestoView.vue?vue&type=style&index=0&id=e6805294&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6805294"]])

export default __exports__